import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { GetAdminMenuAction, GetMenuAction } from './actions/menu.actions';
import { login, logOut, setCompanyId, setClinicId, setSiWeb, setClientId, setProviderId, setRoles } from './actions/profile.actions';
import { toggleSidebar, closeSidebar, openSidebar } from './actions/sidebar.actions';
import { changeUserType } from './actions/toolbar.actions';
import { IAppState } from './interfaces/state';
import { selectProfile, selectToggleSidebar, selectAuthState, selectMenu, selectToolbarUserType } from './reducers';

@Injectable({
  providedIn: 'root'
})
export class StoreFacadeService {

  constructor(private store: Store<IAppState>) {

  }

  selectProfile() {
    return this.store.pipe(select(selectProfile));
  }

  selectSidebarState() {
    return this.store.pipe(select(selectToggleSidebar));
  }

  selectAuthState() {
    return this.store.pipe(select(selectAuthState))
  }

  selectMenu() {
    return this.store.pipe(select(selectMenu))
  }

  selectToolbarUserType() {
    return this.store.pipe(select(selectToolbarUserType));
  }

  dispatchToggleSidebar() {
    this.store.dispatch(toggleSidebar());
  }

  dispatchCloseSidebar() {
    this.store.dispatch(closeSidebar());
  }

  dispatchOpenSideBar() {
    this.store.dispatch(openSidebar());
  }

  dispatchChangeUserType(userType: 'P' | 'C' | 'T') {
    this.store.dispatch(changeUserType({userType}));
  }

  dispatchGetAdminMenu() {
    this.store.dispatch(GetAdminMenuAction());
  }

  dispatchGetMenu() {
    this.store.dispatch(GetMenuAction());
  }

  dispatchLogin(firstName: string, lastName: string, id: number, userType: 'P' | 'C' | 'T', siWeb: number) {
    this.store.dispatch(
      login({
        firstName: firstName,
        lastName: lastName,
        id: id,
        userType: userType,
        siWeb: siWeb
      })
    )
  }

  dispatchLogout() {
    this.store.dispatch(logOut());
  }

  dispatchSetCompanyId(
    id: number | null,
    name: string | null,
    siEstadoCredito: number | null,
    siEstadoCotizacion: number | null,
    siAccesoalaWeb: number | null,
    vcMensajeCliente: string | null,
    siFormaAprobarValorizacion: number | null,
    iIdCotiEmpresa: number | null,
    iVersion: number | null,
    bCargaValorizacionesaContratas: boolean | null,
    bPedirPDFSolicitudEnCita: boolean | null,
    iIdFormatoSolitudEMO: number | null) {
    this.store.dispatch(setCompanyId({
      id,
      name,
      siEstadoCredito,
      siEstadoCotizacion,
      siAccesoalaWeb,
      vcMensajeCliente,
      siFormaAprobarValorizacion,
      iIdCotiEmpresa,
      iVersion,
      bCargaValorizacionesaContratas,
      bPedirPDFSolicitudEnCita,
      iIdFormatoSolitudEMO }));
  }

  dispatchSetClinicId(iIdSede: any, vcNombreSede: any) {
    this.store.dispatch(setClinicId({iIdSede, vcNombreSede}));
  }

  dispatchSetSiWeb(siWeb: any) {
    this.store.dispatch(setSiWeb({siWeb}));
  }

  dispatchSetClientId(idClient: any, vcClient: any) {
    this.store.dispatch(setClientId({iIdClient: idClient, vcClient: vcClient}));
  }

  dispatchSetProviderId(idProvider: any, vcProvider: any) {
    this.store.dispatch(setProviderId({iIdProvider: idProvider, vcProvider: vcProvider}));
  }

  dispatchSetRoles(roles: any[]) {
    this.store.dispatch(setRoles({roles: roles}));
  }
}
